import {Injectable} from 'ng-metadata/core';
import {getStaticHtml} from '../appConfig/customizationConfig';
import {getStaticOtbHtml} from '../appConfig/staticFiles';
const merge = require('lodash/merge');

import {UserSessionManagerService} from '../security/userSessionManager.service';



@Injectable()

export class StaticService {
    private staticHtml:Object = merge(getStaticOtbHtml(), (getStaticHtml() || {}));

    constructor(private userSessionManagerService:UserSessionManagerService) {

    }
    public getTemplateUrl(section) {
        let lang = this.userSessionManagerService.getUserLanguage();
        return this.staticHtml[section][lang] || this.staticHtml[section]['default'];

    }
}
//put here all angular1 modules the service is using
export default [];


// WEBPACK FOOTER //
// ./src/main/webapp/components/static/static.service.ts